module.exports = __webpack_public_path__ + "img/woodpieces.3ca074f4.png";